module.exports = __webpack_public_path__ + "img/kv_3_2.d598b611.png";